import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LocationModal from "../LocationModal";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import ConfirmationModal from "../ConfirmationModal";
import shoppingCart from "../../assets/images/shopping-cart.png";
import LoginPopUp from "../LoginPopup";
import mainLogo from "../../../src/assets/images/new/newLogo.jpg";
import shoppingBag from "../../../src/assets/images/new/shopping-bag.png";
import logoutProfile from "../../../src/assets/images/new/logoutProfile.png";
import wallet from "../../../src/assets/images/new/wallet.png";
import userProfile from "../../../src/assets/images/new/userProfile.png";
import referralIcon from "../../../src/assets/images/new/referralIcon.png";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Prasad_CartList } from "../../ApiServices/Prasad/PrasadApi";
const Navbar = () => {
  const [userCity, setUserCity] = useState(localStorage.getItem("userCity"));
  const [showModal, setShowModal] = useState(!userCity);

  const { isAuthenticated } = useContext(AuthContextProvider);
  const {
    setLoader,
    loader,
    isLocationUpdate,
    setIsLocationUpdate,
    setIsCartUpdate,
    isCartUpdate,
    setPujaStatus,
    pujaStatus
  } = useContext(LoaderContext);
  const [confirmationModal, setConfirmationModal] = useState(null);
  const [onGetOTP, setOnGetOTP] = useState(null);
  const [showLoginPopUp, setShowLoginPopUp] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [itemCount, setItemCount] = useState(0);
  const [PrasadCount, setPrasadCount] = useState(0);
  const [ProductCount, setProductCount] = useState(0);
  const [login, setLogin] = useState(localStorage.getItem("userID"));
  const name = localStorage.getItem("name");
  const isActive = (path) => location.pathname === path;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const count = localStorage.getItem("cartItemCount");
  const prasadCount = localStorage.getItem("PrasadcartCount");
  const [moduleName, setModuleName] = useState("");
  const [open, setOpen] = useState(false);
  const menuRef = useRef();
  const dropdownRef = useRef();
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [isServiceMenuOpen, setIsServiceMenuOpen] = useState(false);
  const { t } = useTranslation();



  const handleLogOut = () => {
    const city = localStorage.getItem("userCity"); // Get before clearing
    setConfirmationModal(false);
    localStorage.clear(); // Clears everything
    if (city) {
      localStorage.setItem("userCity", city); // Restore city
    }
    navigate("/");
    window.location.reload();
  };

  console.log("prasadCount", count);

  useEffect(() => {
    setShowLoginPopUp(false);
  }, [onGetOTP]);

  useEffect(() => {

    if (isCartUpdate) {

      const prasadCount = parseInt(localStorage.getItem("PrasadcartCount")) || 0;
      const count = parseInt(localStorage.getItem("cartItemCount")) || 0;

      const moduleName =
        prasadCount > 0 && count > 0
          ? "All"
          : count > 0
            ? "productBooking"
            : "prasadBooking";

      setModuleName(moduleName);
      setIsCartUpdate(false)
    }

  }, [isCartUpdate]);

  useEffect(() => {
    const updateItemCount = () => {
      const count = localStorage.getItem("cartItemCount");
      const prasadCount = localStorage.getItem("PrasadcartCount");

      let totalProduct = 0;
      let totalPrasad = 0;
      if (count !== null && count !== undefined && count !== "") {
        totalProduct = Number(count);
      }
      if (
        prasadCount !== null &&
        prasadCount !== undefined &&
        prasadCount !== ""
      ) {
        totalPrasad = Number(prasadCount);
      }
      // setItemCount(totalProduct + totalPrasad);
    };

    const prasadCount = parseInt(localStorage.getItem("PrasadcartCount")) || 0;
    const count = parseInt(localStorage.getItem("cartItemCount")) || 0;

    const moduleName =
      prasadCount > 0 && count === 0
        ? "prasadBooking"
        : count > 0 && prasadCount === 0
          ? "productBooking"
          : "All";

    setModuleName(moduleName);
    console.log("moduleName", moduleName);
    const currentLocation = localStorage.getItem("userCity");
    setSelectedLocation(currentLocation);
    // Set the initial count
    updateItemCount();

    // Listen for storage changes from other tabs
    window.addEventListener("storage", updateItemCount);

    // Listen for custom cart updated event within the same tab
    window.addEventListener("cartUpdated", updateItemCount);

    // Cleanup the event listeners on unmount
    return () => {
      window.removeEventListener("storage", updateItemCount);
      window.removeEventListener("cartUpdated", updateItemCount);
    };
  }, []);

  const getProducts = () => {

    const data = localStorage.getItem("userID");
    axios
      .post(`${BaseUrl}/Estore_Cart?USER_ID=${data}`, {
        USER_ID: data,
        START: 1,
        END: 10,
        WORD: "None",
      })
      .then((res) => {

        const productData = res.data.DATA;
        setProductCount(productData?.length)
      });
    GetPrasadCart()
  };
  const GetPrasadCart = async () => {
    const data = localStorage.getItem("userID") || "";
    if (data === null || data === undefined || data === "") {
      return;
    }
    setLoader(true);
    try {
      const response = await Prasad_CartList(
        {
          START: 0,
          END: 100,
          WORD: "none",
        },
        data
      );

      if (response?.ResponseCode == "0") {
        const responseData = response?.DATA || [];
        setLoader(false);
        setPrasadCount(responseData?.length)
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  useEffect(() => {

    setItemCount(Number(PrasadCount) + Number(ProductCount))
  }, [ProductCount, PrasadCount])
  useEffect(() => {
    if (isLocationUpdate) {
      const currentLocation = localStorage.getItem("userCity");
      setSelectedLocation(currentLocation);
      setIsLocationUpdate(false);
    }

    if (isCartUpdate) {
      getProducts()
      setIsCartUpdate(false);
    }
  }, [isLocationUpdate, isCartUpdate]);
  console.log('itemCount', itemCount)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        dropdownRef.current &&
        !menuRef.current.contains(event.target) &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // useEffect(() => {
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  const handleSelectCity = (city) => {
    if (city) {
      localStorage.setItem("userCity", city);
      setUserCity(city);
      setIsLocationUpdate(true);
      setShowModal(false);
    }
  };
  const ChangeLocation = () => {

    setShowModal(true);
  }

  const toggleMenu = () => {
    setOpen(!open);
  };


  const changeLanguage = (e) => {
    const selectedLang = e.target.value;
    i18n.changeLanguage(selectedLang);
  };
  return (
    <>
      <div
        //  className="topbar-two"

        //  className="main-header main-header--four sticky-header sticky-header--normal"
        className="main-header main-header--four sticky-header sticky-header--normal"
        style={{
          position: "fixed",
          width: "100%",

          zIndex: 1000,
          backgroundColor: "#a42642",

          boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          WebkitBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          MozBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
        }}
      >
        <div className="container" style={{ maxWidth: '1300px' }}>
          <div
            className="topbar-two__inner"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <ul className="topbar-two__info">

              <li
                style={{ color: "white" }}
                onMouseEnter={(e) => (e.target.style.color = "white")}
                onMouseLeave={(e) => (e.target.style.color = "white")}
              >
                <span className="topbar-two__info__icon">
                  <i className="icofont-envelope"></i>
                </span>
                <a
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                  href="mailto:info@myomnamo.com"
                >
                  info@myomnamo.com
                </a>
              </li>
              {selectedLocation !== null &&
                selectedLocation !== undefined &&
                selectedLocation !== "" ? (
                <li style={{ color: "white" }}>
                  <span className="topbar-two__info__icon">
                    <i className="icofont-location-pin"></i>
                  </span>
                  <span style={{ cursor: 'pointer' }} onClick={ChangeLocation}>{selectedLocation}</span>
                </li>
              ) : (
                ""
              )}
            </ul>
            {/* <ul className="langSelector">

              <select
                onChange={changeLanguage}
                value={i18n.language}
                style={{
                  padding: '0px 5px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                }}
              >
                <option value="en">English</option>
                <option value="hi">मराठी</option>
              </select>

            </ul> */}
            {isAuthenticated ? (
              <ul className="list-unstyled topbar-two__nav">


                <li
                  className="nav-list"
                  style={{ display: 'flex', height: '30px' }}
                // onMouseEnter={(e) => (e.target.style.color = "white")}
                // onMouseLeave={(e) => (e.target.style.color = "white")}

                >
                  <div className="profile-menu-wrapper" ref={menuRef} style={{ position: "relative" }}>
                    <div
                      className="profile-icon"
                      onClick={toggleMenu}
                      style={{
                        width: "35px",
                        height: "28px",
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        color: "#000",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fa fa-user"></i>
                    </div>


                  </div>
                </li>
                {/* <li
                  className="nav-list"
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <i class="fa-solid fa-right-from-bracket"></i>{" "}
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    onClick={() => setConfirmationModal(true)}
                  >
                    Logout
                  </Link>
                </li> */}
              </ul>
            ) : (
              <ul className="list-unstyled topbar-two__nav">
                {/* <li
                  className="nav-list"
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    to="/login"
                  >
                    Login / Sign Up
                  </Link>
                </li> */}
                {/* <li
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    to="/register"
                  >
                    Register
                  </Link>
                </li> */}
              </ul>
            )}
          </div>
        </div>
      </div >
      {/* Top mobile bar - visible only on mobile */}
      <div
        className="mobile-top-bar"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 16px",
          // backgroundColor: "#a52444",
          borderBottom: "1px solid #eee",
          // position: "sticky",
          top: 0,
          // zIndex: 2000,

          position: "fixed",
          width: "100%",

          zIndex: 1000,
          backgroundColor: "#a42642",

          boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          WebkitBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          MozBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
        }
        }
      >
        <span style={{ fontSize: "14px", color: "#555" }}>
          {selectedLocation !== null &&
            selectedLocation !== undefined &&
            selectedLocation !== "" ? (

            <li style={{ color: "white", listStyle: "none" }}>
              <span className="topbar-two__info__icon">
                <i className="icofont-location-pin"></i>
              </span>
              <span style={{ cursor: 'pointer' }} onClick={ChangeLocation}>{selectedLocation}</span>
            </li>
          ) : (
            ""
          )}
        </span>

        {
          isAuthenticated ? (
            <>

              <div className="profile-menu-wrapper" ref={menuRef} style={{ position: "relative" }}>
                <div
                  className="profile-icon"
                  onClick={toggleMenu}
                  style={{
                    width: "27px",
                    height: "23px",
                    borderRadius: "50%",
                    backgroundColor: "#fff",
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <i className="fa fa-user"></i>
                </div>

                {open && (
                  <div style={{ position: 'absolute', zIndex: 1 }}>
                    {/* Trigger */}
                // <button onClick={() => setOpen(!open)}>Profile</button>

                    {/* Dropdown */}
                    {open && (
                      ReactDOM.createPortal(
                        <ul
                          ref={dropdownRef}
                          className="profile-dropdown"
                          style={{
                            position: "fixed",
                            top: "40px",
                            right: 0,
                            backgroundColor: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                            listStyle: "none",
                            padding: "10px",
                            width: "171px",
                            zIndex: 999999,
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>
                            <Link
                              className="ProfileIcons"
                              to="/my-profile"
                              onClick={() => {
                                setTimeout(() => setOpen(false), 500); // allow Link to work
                              }}

                            >
                              {/* <i class="fa-regular fa-user  " style={{ margin: '0px 5px' }}></i> */}
                              <img src={userProfile} width={20} height={20} className="ProfileIcons"></img>
                              My Profile
                            </Link>

                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            <Link
                              to="/wallet"
                              className="ProfileIcons"

                              onClick={() => {
                                setTimeout(() => setOpen(false), 0); // allow Link to work
                              }} >
                              {/* <i class="fa-solid fa-wallet ProfileIcons" style={{ margin: '0px 5px' }} ></i> */}
                              <img src={wallet} width={20} height={20} className="ProfileIcons"></img>
                              My Wallet</Link>
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            <Link
                              className="ProfileIcons"

                              to="/my-order-list"
                              onClick={() => {
                                setTimeout(() => setOpen(false), 0); // allow Link to work
                              }}
                            >
                              {/* <i
                            class="fa-solid fa-bag-shopping"
                            style={{ margin: '0px 5px' }}
                          ></i>{" "} */}
                              <img src={shoppingBag} width={20} height={20} className="ProfileIcons"></img>
                              My Order
                            </Link>
                          </li>
                          <li style={{ marginBottom: "8px" }}>
                            <Link
                              className="ProfileIcons"
                              to="/refer-and-earn"
                              onClick={() => {
                                setTimeout(() => setOpen(false), 500); // allow Link to work
                              }}

                            >
                              {/* <i class="fa-regular fa-user  " style={{ margin: '0px 5px' }}></i> */}
                              <img src={userProfile} width={20} height={20} className="ProfileIcons"></img>
                              My Referrals
                            </Link>

                          </li>
                          <li>
                            <span
                              className="ProfileIcons"

                              onClick={() => {
                                setOpen(false);

                                setConfirmationModal(true);
                              }}
                              style={{ cursor: "pointer", textDecoration: 'none' }}
                            >
                              {/* <i class="fa-solid fa-right-from-bracket ProfileIcons" style={{ margin: '0px 5px' }}></i> */}
                              <img src={logoutProfile} width={20} height={20} className="ProfileIcons"></img>
                              Logout
                            </span>
                          </li>
                        </ul>,
                        document.body
                      )
                    )}
                  </div>

                )}
              </div>
            </>

          ) : (
            <button
              onClick={() => setShowLoginPopUp(true)}
              style={{
                fontSize: "14px",
                color: "white",
                fontWeight: "bold",
                border: "none",
                background: "none",
              }}
            >
              Login
            </button>
          )
        }
      </div >

      <header
        className="main-header main-header--four sticky-header sticky-header--normal"
        style={{
          position: "fixed",
          top: "35px",
          left: 0,
          width: "100%",
          zIndex: 1000,
          backgroundColor: "#fff",
          boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          WebkitBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          MozBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
        }}
      >
        <div className="container-fluid">
          <div className="main-header__inner">
            <div className="main-header__logo">
              <Link to="/">
                <img src={mainLogo} height="80px" width="223px" alt="Logo" />
              </Link>
            </div>

            <nav className="main-header__nav main-menu">
              <ul className="main-menu__list">
                <li>
                  <Link
                    to="/"
                    style={{ color: isActive("/") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                  >
                    {t('Home')}

                  </Link>
                </li>
                {/* <li>
                  <Link
                    to="/about-us"
                    style={{
                      color: isActive("/about-us") ? "#d09d18" : "black",
                    }}
                  >
                    About Us
                  </Link>
                </li> */}
                <li>
                  {/* Dropdown trigger */}
                  <Link
                    to="#"
                    className="how-we-help-hover"
                    onClick={(e) => {
                      e.preventDefault();
                      setServicesDropdownOpen(!servicesDropdownOpen);
                    }}
                    style={{
                      color: isActive("#") ? "#d09d18" : "black",
                      gap: "5px",
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center', textWrap: 'nowrap'
                    }}
                  >
                    {t('Our Services')}

                    <i
                      className="fas fa-chevron-down"
                      style={{ fontSize: "12px", marginLeft: "5px" }}
                    ></i>
                  </Link>

                  {/* Conditional dropdown */}
                  {servicesDropdownOpen && (
                    <ul>
                      <li>
                        <Link
                          to="/services/puja-booking"

                          onClick={() => {
                            setPujaStatus(false);
                            setServicesDropdownOpen(false);
                          }}
                        >
                          {t('Offline Puja Booking')}
                          {/* Offline Puja Booking */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/online-puja-services"

                          onClick={() => {
                            setPujaStatus(true);
                            setServicesDropdownOpen(false);
                          }}
                        >
                          {t('Online Puja Booking')}
                          {/* Online Puja Booking */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/daily-puja-booking"

                          onClick={() => setServicesDropdownOpen(false)}
                        >
                          {t('Daily Puja Booking')}
                          {/* Daily Puja Booking */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/e-store"

                          onClick={() => setServicesDropdownOpen(false)}
                        >
                          {t('E-Store')}
                          {/* E-Store */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/darshan-booking"

                          onClick={() => setServicesDropdownOpen(false)}
                        >
                          {t('Darshan Booking')}
                          {/* Darshan Booking */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/temple-puja"

                          onClick={() => setServicesDropdownOpen(false)}
                        >
                          {t('Puja At Temple')}
                          {/* Puja At Temple */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/online-prasad-booking"

                          onClick={() => setServicesDropdownOpen(false)}
                        >
                          {t('Prasad Booking')}
                          {/* Prasad Booking */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/horoscope"

                          onClick={() => setServicesDropdownOpen(false)}
                        >
                          {t('Horoscope')}
                          {/* Horoscope */}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/puja-kit-services"

                          onClick={() => setServicesDropdownOpen(false)}
                        >
                          {t('Bhakti Puja Kit')}
                          {/* Bhakti Puja Kit */}
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>

                <li>
                  <Link
                    to="/temple"
                    style={{
                      color: isActive("/temple") ? "#d09d18" : "black",
                      textDecoration: 'none'
                    }}
                  >
                    {t('Temples')}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/spiritual-gyan"
                    style={{
                      color: isActive("/spiritual-gyan") ? "#d09d18" : "black",
                      textDecoration: 'none', textWrap: 'nowrap'
                    }}
                  >
                    {t('Spiritual Gyan')}

                  </Link>
                </li>

                <li>
                  <Link
                    to="/contact-us"
                    style={{
                      color: isActive("/contact-us") ? "#d09d18" : "black",
                      textDecoration: 'none', textWrap: 'nowrap'
                    }}
                  >
                    {t('Contact Us')}

                  </Link>
                </li>
              </ul>
            </nav>
            <Link
              to="/view-cart"
              state={{
                moduleName: moduleName,
              }}
              className="main-header__cart position-relative "

            >
              {isAuthenticated ? (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <img src={shoppingCart} width={30} height={30} alt="Cart" />
                  {itemCount > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-5px",
                        right: "-5px",
                        background: "#8f3246",
                        borderRadius: "50%", // Ensure full round shape
                        width: "20px", // Fixed width
                        height: "20px", // Fixed height
                        display: "flex", // Center the text
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "white",
                      }}
                      className="cart-badge"
                    >
                      {itemCount}
                    </span>
                  )}
                </div>
              ) : (
                <Link onClick={() => setShowLoginPopUp(true)}>
                  <span className="login-signup-nav" >Login</span>
                </Link>
                // <Link onClick={() => navigate("/login")}>
                //   <span className="login-signup-nav">Login/signup</span>
                // </Link>
              )}
            </Link>
            <div className="main-header__right">
              {/* Mobile Nav Toggle Button */}
              <div className="d-flex justify-content-between d-sm-none d-md-none " style={{ width: '5em' }}>
                <div className="mobile-nav__btn ">

                  <div onClick={() => {
                    setIsMobileMenuOpen((prev) => !prev)
                    navigate('/view-cart', {
                      state: {
                        moduleName: moduleName,
                      },
                    })
                  }
                  } style={{ position: "relative", display: "inline-block", left: '15px', bottom: '7px' }}>
                    <img src={shoppingCart} width={30} height={30} alt="Cart" />
                    {itemCount > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",

                          background: "#8f3246",
                          borderRadius: "50%", // Ensure full round shape
                          width: "20px", // Fixed width
                          height: "20px", // Fixed height
                          display: "flex", // Center the text
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "white",
                        }}
                        className="cart-badge"
                      >
                        {itemCount}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className="mobile-nav__btn mobile-nav__toggler"
                  onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                >

                  <i
                    className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}
                  ></i>
                </div>
              </div>


              {/* Mobile Nav Menu (show when open) */}
              {isMobileMenuOpen && (
                <div
                  className="mobile-menu shadow-lg"
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    width: "100%",
                    backgroundColor: "#fff",
                    zIndex: 9999,
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    height: '20em',
                    overflowY: 'auto'
                  }}
                >
                  <ul className="list-unstyled m-0 p-3">
                    <li className="mb-2">
                      <Link
                        to="/"
                        className="d-block  text-decoration-none py-2 px-3 rounded hover-bg"
                        onClick={() => {
                          setIsServiceMenuOpen(false)
                          setIsMobileMenuOpen(false)
                        }}
                        style={{ color: isActive("/") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                      >
                        Home
                      </Link>
                    </li>

                    {/* Our Services dropdown */}
                    <li className="mb-2">
                      <div
                        className="d-flex justify-content-between align-items-center text-dark text-decoration-none py-2 px-3 rounded hover-bg fw-bold"
                        onClick={() => setIsServiceMenuOpen(!isServiceMenuOpen)}
                        style={{ cursor: "pointer" }}
                      >
                        <span>Our Services</span>
                        <span>{isServiceMenuOpen ? "−" : "+"}</span> {/* Toggle Icon */}
                      </div>

                      {isServiceMenuOpen && (
                        <ul className="list-unstyled ps-3">
                          {[
                            { path: "/services/puja-booking", label: "Puja Booking" },
                            { path: "/services/daily-puja-booking", label: "Daily Puja Booking" },
                            { path: "/services/e-store", label: "E-Store" },
                            { path: "/services/darshan-booking", label: "Darshan Booking" },
                            { path: "/services/temple-puja", label: "Puja At Temple" },
                            { path: "/services/online-prasad-booking", label: "Prasad Booking" },
                            { path: "/services/horoscope", label: "Horoscope" },
                            { path: "/services/puja-kit-services", label: "Bhakti Puja Kit" },
                          ].map((subItem, index) => (
                            <li key={index} className="mb-1">
                              <Link
                                to={subItem.path}
                                className="d-block  text-decoration-none py-1 px-3 rounded hover-bg"
                                onClick={() => {
                                  setIsMobileMenuOpen(false)
                                  setIsServiceMenuOpen(false)
                                }}
                                style={{ color: isActive(subItem.path) ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                              >
                                {subItem.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                    <li className="mb-2">
                      <Link
                        to="/temple"
                        className="d-block  text-decoration-none py-2 px-3 rounded hover-bg"
                        onClick={() => {
                          setIsServiceMenuOpen(false)
                          setIsMobileMenuOpen(false)
                        }}
                        style={{ color: isActive("/temple") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                      >
                        Temples
                      </Link>
                    </li>

                    {/* Other Items */}
                    <li className="mb-2">
                      <Link
                        to="/spiritual-gyan"
                        className="d-block  text-decoration-none py-2 px-3 rounded hover-bg"
                        onClick={() => {
                          setIsServiceMenuOpen(false)
                          setIsMobileMenuOpen(false)
                        }}
                        style={{ color: isActive("/spiritual-gyan") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                      >
                        Spiritual Gyan
                      </Link>
                    </li>

                    <li className="mb-2">
                      <Link
                        to="/contact-us"
                        className="d-block  text-decoration-none py-2 px-3 rounded hover-bg"
                        onClick={() => {
                          setIsServiceMenuOpen(false)
                          setIsMobileMenuOpen(false)
                        }}
                        style={{ color: isActive("/contact-us") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                      >
                        Contact Us
                      </Link>
                    </li>

                    {/* Login/Logout */}
                    <li className="mt-3 border-top pt-3">
                      {isAuthenticated ? (
                        <Link
                          className="d-block text-danger fw-semibold text-decoration-none py-2 px-3 rounded hover-bg"
                          onClick={() => setConfirmationModal(true)}
                        >
                          Logout
                        </Link>
                      ) : (
                        <Link
                          className="d-block text-danger fw-semibold text-decoration-none py-2 px-3 rounded hover-bg"
                          onClick={() => setShowLoginPopUp(true)}
                        >
                          Login
                        </Link>
                      )}
                    </li>
                  </ul>

                </div>
              )}


              {/* <Link target="__blank" className="careox-btn"> */}
              <a
                className="download-app-btn"
                href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                target="_blank"
                rel="noopener noreferrer"

              >
                <span style={{ fontFamily: "Poppins", textWrap: 'nowrap' }}>
                  Download App &nbsp;
                  <i className="icofont-download"></i>
                </span>
              </a>

              {/* </Link> */}
            </div>
          </div>
        </div>
      </header >
      <ConfirmationModal
        show={confirmationModal}
        onHide={() => setConfirmationModal(false)}
        onConfirm={handleLogOut}
      />
      <LoginPopUp
        show={showLoginPopUp}
        onHide={() => setShowLoginPopUp(false)}
        setOnGetOTP={setOnGetOTP}
      />

      {
        showModal && (
          <LocationModal
            show={showModal}
            onHide={() => setShowModal(false)}
            onSelectCity={handleSelectCity}
          />
        )
      }
    </>
  );
};

export default Navbar;
